import { makeStyles } from '@material-ui/core/styles';
import { alpha as fade } from '@material-ui/core/styles/colorManipulator';
const drawerWidth = 360;
const drawerClosedWidth = 80;

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  mobileAppLogo: {
    width: '100%',
  },
  groupTitle: {
    transition: theme.transitions.create('color', {
      easing: theme.transitions.easing.sharp,
      duration: 250,
    }),
    color: `${theme.palette.primary.main} !important`,
    paddingLeft: 20,
  },
  groupTitleActive: {
    color: `${theme.palette.common.black} !important`,
  },
  groupIconInactive: {
    transition: theme.transitions.create(['color', 'background-color', 'box-shadow'], {
      easing: theme.transitions.easing.sharp,
      duration: 250,
    }),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'baseline',
    padding: 10,
    marginLeft: -10,
    marginRight: -10,
    borderRadius: '14px',
    backgroundColor: fade(theme.palette.primary.main, 0.1),
    color: theme.palette.primary.main,
    boxShadow: `0 4px 8px 0 ${fade(theme.palette.secondary.main, 0)}`,
  },
  groupIconActive: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.common.white,
    boxShadow: `0 4px 8px 0 ${fade(theme.palette.secondary.main, 0.3)}`,
  },
  inactive: {
    paddingLeft: 20,
    paddingRight: 16,
    color: theme.palette.gray.main,
    borderLeft: `2px solid transparent`,
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
    '&:hover': {
      color: theme.palette.secondary.main,
      borderLeftColor: theme.palette.secondary.main,
      '& > span': {
        color: theme.palette.secondary.main,
      },
    },
    '& > span': {
      paddingLeft: 10,
      color: theme.palette.gray.light,
      whiteSpace: 'nowrap',
    },
  },
  active: {
    color: `${theme.palette.secondary.main} !important`,
    borderLeft: `2px solid ${theme.palette.secondary.main}`,
    '& > span': {
      color: `${theme.palette.secondary.main} !important`,
    },
  },
  groupInactive: {
    paddingLeft: 20,
    cursor: 'pointer',
    '&:hover': {
      borderLeftColor: 'transparent',
    },
  },
  groupActive: {},
  groupDisabled: {
    cursor: 'not-allowed',
    color: `${theme.palette.gray.main} !important`,

    '&:hover': {
      borderLeftColor: 'transparent',
    },
  },
  menuDivider: {
    marginLeft: 22,
    width: 22,
    backgroundColor: theme.palette.gray.divider,
  },
  appBar: {
    zIndex: theme.zIndex.drawer - 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  hide: {
    display: 'none',
  },
  drawer: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      position: 'absolute',
      flexShrink: 1,
    },
  },
  drawerOpen: {
    width: drawerWidth,
    minWidth: drawerWidth,
    maxWidth: drawerWidth,
    boxSizing: 'border-box',
    border: 0,
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    [theme.breakpoints.up('sm')]: {
      position: 'relative',
      height: '100%',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: 1,
      paddingRight: 0,
      backgroundColor: theme.palette.gray.background,
      width: '100%',
      minWidth: '100%',
      maxWidth: '100%',
      height: `calc(100% - 80px)`,
      whiteSpace: 'normal',
      transition: theme.transitions.create('height', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
  },

  drawerClose: {
    border: 0,
    overflowX: 'hidden',
    width: drawerClosedWidth,
    minWidth: drawerClosedWidth,
    maxWidth: drawerClosedWidth,
    boxSizing: 'border-box',
    '& $groupInactive': {
      paddingLeft: 0,
      justifyContent: 'center',
    },
    '& $groupIconInactive': {
      marginLeft: 0,
      marginRight: 0,
    },
    '& $inactive': {
      paddingLeft: 0,
      paddingRight: 0,
      justifyItems: 'center',
      gridTemplateColumns: 'auto',
    },
    [theme.breakpoints.up('sm')]: {
      position: 'relative',
      height: '100%',
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      minWidth: '100%',
      maxWidth: '100%',
      height: '0%',
      transition: theme.transitions.create('height', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
    },
  },

  drawerLitleHeight: {
    // width: 80,
  },
  topPart: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    paddingLeft: 0,
    marginBottom: 9,
    flex: '0 0 80px',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  icon: {
    minWidth: 'auto',
    marginRight: 20,
    paddingLeft: 5,
  },
  menuList: {
    width: '100% !important',
    marginLeft: '0 !important',
    marginRight: '0 !important',
    boxSizing: 'border-box',
  },
  groupContent: {
    width: '100% !important',
    marginLeft: '0 !important',
    marginRight: '0 !important',
    boxSizing: 'border-box',
  },
  containerEzSearch: {
    marginBottom: 20,
  },
  containerPremiumBanner: {
    padding: 10,
  },
}));
